import React, {
  ReactNode,
  forwardRef,
  useImperativeHandle,
  useRef,
  useState,
} from 'react';
import {SortFilter, SortType} from '../components/filter';

export interface TeamHeadTitle {
  columnKey: string;
  text: string;
  hasSort?: boolean;
  className?: string;
}

export interface TeamTableHeadProps {
  className?: string;
  topContent?: ReactNode;
  headTitles: TeamHeadTitle[];
  // 排序项改变事件，key代表对应的列key，value代表排序
  onChangeSort?: (sorts: Record<string, SortType>) => void;
  onScroll?: (scrollLeft: number) => void;
  isEmpty?: boolean;
}

export interface TeamTableScrollRef {
  scrollTo: (left: number) => void;
}

const TeamTableHead = forwardRef<TeamTableScrollRef, TeamTableHeadProps>(
  (
    {className, topContent, headTitles, onChangeSort, onScroll, isEmpty},
    ref,
  ) => {
    const [sortMap, setSortMap] = useState<Record<string, SortType>>({});
    const tableHeaderScrollRef = useRef<HTMLDivElement>(null);

    const handleSortChange = (columnKey: string, sort: SortType) => {
      const newSortMap = {
        ...sortMap,
        [columnKey]: sort,
      };
      setSortMap(newSortMap);
      onChangeSort?.(newSortMap);
    };

    useImperativeHandle(
      ref,
      () => {
        return {
          scrollTo(left: number) {
            tableHeaderScrollRef.current?.scrollTo({left});
          },
        };
      },
      [],
    );

    const handleScroll = () => {
      setTimeout(() => {
        const scrollLeft = tableHeaderScrollRef.current?.scrollLeft;
        onScroll?.(scrollLeft || 0);
      }, 20);
    };

    return (
      <div className={`flex flex-col gap-y-3 ${className}`}>
        {topContent}
        {!isEmpty && (
          <div
            className="flex flex-row overflow-x-auto bg-gray-200 h-8 text-xs text-gray-600 gap-x-2"
            ref={tableHeaderScrollRef}
            onScroll={handleScroll}>
            {headTitles.map((title, index) => (
              <div
                className={`${
                  index === 0
                    ? 'border-r border-white sticky left-0 bg-gray-200 z-[1]'
                    : ''
                } flex-none flex items-center ${title.className}`}
                key={title.columnKey}>
                {title.hasSort ? (
                  <SortFilter
                    sort={sortMap?.[title.columnKey] || 'none'}
                    onChange={sort => handleSortChange(title.columnKey, sort)}>
                    {title.text}
                  </SortFilter>
                ) : (
                  title.text
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    );
  },
);

export default TeamTableHead;
